import { createContext, useContext } from "react";

const WorkspaceContext = createContext<
  | {
      dataflowId: string | undefined;
      projectId: string | undefined;
    }
  | undefined
>(undefined);

export function useWorkspaceContext() {
  const context = useContext(WorkspaceContext);
  return context;
}

/**
 * Hook to get the current workspace's dataflowId.
 * Returns undefined if not within a workspace context.
 */
export function useWorkspaceDataflowId(): string | undefined {
  const context = useWorkspaceContext();
  return context?.dataflowId;
}

/**
 * Hook to get the current workspace's projectId.
 * Returns undefined if not within a workspace context.
 */
export function useWorkspaceProjectId(): string | undefined {
  const context = useWorkspaceContext();
  return context?.projectId;
}

export function WorkspaceProvider({
  dataflowId,
  projectId,
  children,
}: {
  dataflowId: string | undefined;
  projectId: string | undefined;
  children: React.ReactNode;
}) {
  return (
    <WorkspaceContext.Provider value={{ dataflowId, projectId }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

